/**
 * Persists data in sessionStorage and tracks via URL param
 */
export var getSessionStateAPI = function getSessionStateAPI(_ref) {
  var getWindow = _ref.getWindow;
  return {
    /**
     * Save data and return URL with tracking param
     */
    save: function save(paramName, data) {
      try {
        var window = getWindowOrThrow(getWindow);
        var url = new URL(window.location.href);
        var stateId = url.searchParams.get(paramName) || Date.now().toString();
        sessionStorage.setItem(paramName, JSON.stringify(data));
        url.searchParams.set(paramName, stateId);
        return url.toString();
      } catch (e) {
        console.error(e);
        return '';
      }
    },
    /**
     * Get data if tracking param exists
     */
    get: function get(paramName) {
      try {
        var data = sessionStorage.getItem(paramName);
        return data ? JSON.parse(data) : undefined;
      } catch (e) {
        console.error(e);
        return undefined;
      }
    },
    /**
     * Clear stored data and URL param
     */
    clear: function clear(paramName) {
      try {
        var window = getWindowOrThrow(getWindow);
        sessionStorage.removeItem(paramName);
        var url = new URL(window.location.href);
        url.searchParams.delete(paramName);
        window.history.replaceState(null, '', url);
      } catch (e) {
        console.error(e);
      }
    }
  };
};
var getWindowOrThrow = function getWindowOrThrow(getWindow) {
  var window = getWindow();
  if (!window) throw new Error('no window object');
  return window;
};